// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__rjQkX","searchInput":"SearchBar_searchInput__S8ff+"};